import { makeStyles } from 'tss-react/mui'

import { Theme } from '@mui/material'
import { createStyles } from '@mui/styles'

const styles = ({ spacing }: Theme) =>
  createStyles({
    header: {
      marginBottom: spacing(2),
    },
    sectionContainer: {
      marginTop: spacing(4),
      marginBottom: spacing(2),
    },
    sectionItem: {
      marginTop: spacing(2),
    },
  })

export default styles

export const useStyles = makeStyles()(({ spacing }: Theme) => ({
  header: {
    marginBottom: spacing(2),
  },
  sectionContainer: {
    marginTop: spacing(4),
    marginBottom: spacing(2),
  },
  sectionItem: {
    marginTop: spacing(2),
  },
}))
